<template>
   <div class="table-responsive mb-0">
      <div class="row">
            <div class="col">
               <div class="form-group row">
                  <label class="col-xl-2 col-form-label">Seleccionar Familia:</label>
                  <div class="col-xl-3">
                     <select v-model="familiaSeleccionada" class="form-control custom-select">
                        <option>Todas las familias</option>
                        <option v-for="familia in familias" :key="familia">{{ familia }}</option>
                     </select>
                  </div>
               </div>
            </div>
         </div>
      <table class="table table-centered table-nowrap text-center">
         <thead class="thead-light">
            <tr>
               <th>Año</th>
               <th>Ene.</th>
               <th>Feb.</th>
               <th>Mar.</th>
               <th>Abr.</th>
               <th>May.</th>
               <th>Jun.</th>
               <th>Jul.</th>
               <th>Ago.</th>
               <th>Sep.</th>
               <th>Oct.</th>
               <th>Nov.</th>
               <th>Dic.</th>
               <th>Total</th>
            </tr>
         </thead>
         <tbody v-for="(familia, index) in ventasFamiliasFiltrado" :key="index">
            <tr>
               <th style="text-align: left;">{{ familia.nombre }} ({{ year }})</th>
               <td>{{ familia.act01 | currency }}</td>
               <td>{{ familia.act02 | currency }}</td>
               <td>{{ familia.act03 | currency }}</td>
               <td>{{ familia.act04 | currency }}</td>
               <td>{{ familia.act05 | currency }}</td>
               <td>{{ familia.act06 | currency }}</td>
               <td>{{ familia.act07 | currency }}</td>
               <td>{{ familia.act08 | currency }}</td>
               <td>{{ familia.act09 | currency }}</td>
               <td>{{ familia.act10 | currency }}</td>
               <td>{{ familia.act11 | currency }}</td>
               <td>{{ familia.act12 | currency }}</td>
               <td>{{ familia.ventaejer | currency }}</td>
            </tr>
               <tr>
                  <th style="text-align: left;">{{ familia.nombre }} ({{ year - 1}})</th>
                  <td>{{ familia.ant01 | currency }}</td>
                  <td>{{ familia.ant02 | currency }}</td>
                  <td>{{ familia.ant03 | currency }}</td>
                  <td>{{ familia.ant04 | currency }}</td>
                  <td>{{ familia.ant05 | currency }}</td>
                  <td>{{ familia.ant06 | currency }}</td>
                  <td>{{ familia.ant07 | currency }}</td>
                  <td>{{ familia.ant08 | currency }}</td>
                  <td>{{ familia.ant09 | currency }}</td>
                  <td>{{ familia.ant10 | currency }}</td>
                  <td>{{ familia.ant11 | currency }}</td>
                  <td>{{ familia.ant12 | currency }}</td>
                  <td>{{ familia.ventames | currency }}</td>
               </tr>
         </tbody>
      </table>
   </div>
</template>

<script>
   export default {
      props: {
         ventas: {
            type: Array,
            default: function() {
            return [];
            }
         }
      },
      data() {
         return {
            ventasFamilias: [],
            familias: [],
            familiaSeleccionada: 'Todas las familias'
         }
      },
      computed: {
         year (){ 
            return new Date().getFullYear()
         },
         ventasFamiliasFiltrado () {
            if (this.familiaSeleccionada == 'Todas las familias') {
               return this.ventasFamilias
            } else {
               return this.ventasFamilias.filter(familia => familia.nombre == this.familiaSeleccionada)
            }
         },
      },
      mounted () {
         this.ventas.forEach(element => {
            this.familias.push(element.nombre)
         })
         this.familias.sort()

         this.familias.forEach(element => {
            var temporal
            temporal = this.ventas.filter(familia => familia.nombre == element)
            this.ventasFamilias.push(temporal[0])
         })
      }
   };
</script>